import request from '@/utils/request';

function apiSaveMappings(mappings) {
  return request({
    data: mappings,
    method: 'put',
    url: '/producttypemapping/saveMappings'
  });
}

function apiReadMappings() {
  return request({
    method: 'get',
    url: '/producttypemapping/readMappings'
  });
}

function apiReadWebAtelierProductTypes() {
  return request({
    method: 'get',
    url: '/producttypemapping/readWebAtelierProductTypes'
  });
}

export const storeExtensions = {
  actions: {
    saveMappings({ commit }, mappings) {
      return apiSaveMappings(mappings);
    },
    readMappings({ dispatch }) {
      return apiReadMappings();
    },
    readWebAtelierProductTypes({ dispatch }) {
      return apiReadWebAtelierProductTypes();
    }
  }
};
